import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TypographyTheme from './TypographyTheme';
import ClientProvider from './client';
export default createDemo(import.meta.url, TypographyTheme, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/typography/demos/theme/TypographyTheme.tsx",
    "fileName": "TypographyTheme.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\n\nconst Div = styled('div')(({ theme }) => ({\n  ...theme.typography.button,\n  backgroundColor: (theme.vars || theme).palette.background.paper,\n  padding: theme.spacing(1),\n}));\n\nexport default function TypographyTheme() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Div>{\"This div's text looks like that of a button.\"}</Div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 13,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\n\nconst Div = styled('div')(({ theme }) => ({\n  ...theme.typography.button,\n  backgroundColor: (theme.vars || theme).palette.background.paper,\n  padding: theme.spacing(1),\n}));\n\nexport default function TypographyTheme() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Div>{\"This div's text looks like that of a button.\"}</Div>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Div"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "This div's text looks like that of a button.",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-c1 di-jsx",
                "Div"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 13,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
